import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';


import Home from './pages/Home.tsx'; // or Home.jsx if you're not using TypeScript
import './index.css';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
       
        
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </main>
        
        
      </div>
    </Router>
  );
}

export default App;
